<app-header>Curriculum Sessions</app-header>

<div class="content">
  <div class="toolbar">
    <div class="toolbar-left">
      <input
        class="search-input"
        type="text"
        placeholder="Search by unit title..."
        [value]="searchTerm"
        (input)="onSearch($any($event.target).value)"
      />
      <div class="filter-toggle">
        <button [class.active]="filter === 'all'" (click)="setFilter('all')">All</button>
        <button [class.active]="filter === 'unreviewed'" (click)="setFilter('unreviewed')">Unreviewed</button>
        <button [class.active]="filter === 'approved'" (click)="setFilter('approved')">Approved</button>
      </div>
    </div>
    <div class="toolbar-right">
      @if (unreviewedCount > 0) {
        <button class="btn-review" (click)="goToReview()">
          Review Queue <span class="badge">{{ unreviewedCount }}</span>
        </button>
      }
      <button class="btn-primary" (click)="goToNew()">+ New Sessions</button>
    </div>
  </div>

  @if (loading) {
    <app-loader></app-loader>
  }

  @if (!loading) {
    <table class="sessions-table">
      <thead>
        <tr>
          <th class="col-session">#</th>
          <th class="col-unit">Unit</th>
          <th class="col-age">Age Band</th>
          <th class="col-skill">Skill</th>
          <th class="col-goal">Goal</th>
          <th class="col-status">Status</th>
          <th class="col-date">Created</th>
          <th class="col-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (s of sessions; track s.sessionId) {
          <tr>
            <td>{{ s.sessionOrder }}</td>
            <td>{{ s.unitTitle }}</td>
            <td>
              @if (s.ageTitle) {
                <span class="curriculum-tag age-tag">{{ s.ageTitle }}</span>
              }
              @if (!s.ageTitle) {
                <span class="curriculum-tag-empty">—</span>
              }
            </td>
            <td>
              @if (s.skillTitle) {
                <span>{{ s.skillTitle }}</span>
              }
              @if (!s.skillTitle) {
                <span class="curriculum-tag-empty">—</span>
              }
            </td>
            <td>
              @if (s.goalTitle) {
                <span>{{ s.goalTitle }}</span>
              }
              @if (!s.goalTitle) {
                <span class="curriculum-tag-empty">—</span>
              }
            </td>
            <td>
              <span class="status-badge" [class.approved]="s.clinicalApproved" [class.unreviewed]="!s.clinicalApproved">
                {{ s.clinicalApproved ? 'Approved' : 'Unreviewed' }}
              </span>
            </td>
            <td>{{ s.createdAt | date: 'mediumDate' }}</td>
            <td class="actions">
              <button class="btn-link" (click)="goToEdit(s.sessionId)">Edit</button>
              <button class="btn-link danger" (click)="confirmDelete(s)">Delete</button>
            </td>
          </tr>
        }
        @if (sessions.length === 0) {
          <tr>
            <td colspan="8" class="empty-state">No sessions found.</td>
          </tr>
        }
      </tbody>
    </table>
  }
  <list-paginator
    [currentPage]="currentPage"
    [class]="loading ? 'hidden' : ''"
    [totalPages]="totalPages"
    (onPageChange)="onPageChange($event)"
  ></list-paginator>
</div>
